export default class Affiliate {
    constructor() {
        this.validStores = [];
    }
    prepareCookie() {}
    setUrlParams(urlParams) {
        this.urlParams = urlParams;
    }
    isStoreSupported (storeCode) {
        return this.validStores.includes(storeCode)
    }
}



// WEBPACK FOOTER //
// ./src/Common/Helpers/TrackingAffiliate/Affiliate.js